/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.RatingsControlPanel {
    export enum DataListViewTypesEnum {
        Summary = 0,
        Detailed,
    }

    export enum DisplayRatingTypesEnum {
        All = 0,
        Published,
        Unpublished,
        Deleted,
    }
}
